import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { SearchesCommon } from '../searches.common';

import { SearchEngineTypeValue } from 'modules/shared/models/screening.models';

@Component({
  selector: 'artemis-searches-artemiscan',
  templateUrl: './searches-artemiscan.component.html',
  styleUrls: ['./searches-artemiscan.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SearchesArtemiscanComponent extends SearchesCommon {

  protected searchEngine: SearchEngineTypeValue = SearchEngineTypeValue.ARTEMISCAN;

  isActive: string = 'alias';
  isLoading: boolean = false;

  displayedColumns: Array<string> = ['checkbox', 'name', 'alias', 'list', 'concatAl', 'matched'];
  currentPage: number;
}

